import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { CalendarService } from '../../services/calendar/calendar.service';
import _ from 'lodash';

@Component({
	selector: 'pcm-page-invoice-calendars',
	templateUrl: './page-invoice-calendars.component.html',
	styleUrls: ['./page-invoice-calendars.component.scss']
})
export class PageInvoiceCalendarsComponent implements OnInit {

	title = 'Invoice Calendars';
	showConfirmationModal = false;
	formData;
	helpText = '';
	submitLabel = 'Confirm';

	constructor(
		public dataService: DataService,
		public configService: ConfigService,
		public calendarService: CalendarService
	) { }

	ngOnInit() {
		this.calendarService.selectDefaultTab(this.calendarService.tabsData.listTabs);
		this.calendarService.loadAllCountryNames();
	}

	pageFormSubmit(event) {
		this.submitLabel = 'Confirm';

		// remove billing dates if calendar is monthly
		if (event.data[this.configService.invoiceCalIsMonthlyProp]) {
			event.data[this.configService.invoiceBillingPeriodsProp] = [];
		}
		// need convert countryname to countrycode for payload
		if (event.data['countryname']) {
			event.data['countrycode'] = this.dataService.countries[event.data['countryname']][0];
		}
		// Country default is checked
		if (event.data[this.configService.calendarIsDefaultProp]) {
			if (event.data[this.configService.invoiceCalIsMonthlyProp]) {
				this.helpText = 'Monthly invoice calendar cannot be set as default.';
				this.submitLabel = '';
				this.showConfirmationModal = true;
			} else if (_.isEmpty(this.calendarService.defaultIDs)		// no default cal at all for the whole supplier
				|| !this.calendarService.defaultIDs[event.data.countrycode]			// no default cal for the selected country
				|| this.calendarService.defaultIDs[event.data.countrycode] === event.data.id) {
				this.showConfirmationModal = false;
				this.calendarService.submitInvoiceCal(event.data);
			} else {
				this.helpText = 'There is already an existing invoice calendar set up as "Country Default" for the selected country. Only one default invoice calendar is allowed per country. Are you sure you want to overwrite the existing country default with this calendar?';
				this.formData = event.data;
				this.showConfirmationModal = true;
			}
		} else {
			// there is an existing default cal
			if (!_.isEmpty(this.calendarService.defaultIDs) && this.calendarService.defaultIDs[event.data.countrycode]) {
				if (this.calendarService.defaultIDs[event.data.countrycode] === event.data.id) {
					this.submitLabel = '';
					this.helpText = 'Default invoice calendar is required, you can not remove the default. You may change/overwrite the existing country default by creating/updating an invoice calendar as the new country default.';
					this.showConfirmationModal = true;
				} else {
					this.showConfirmationModal = false;
					this.calendarService.submitInvoiceCal(event.data);
				}
			} else if (event.data[this.configService.invoiceCalIsMonthlyProp]) {
				this.showConfirmationModal = false;
				this.calendarService.submitInvoiceCal(event.data);
			} else {
				this.formData = event.data;
				this.formData[this.configService.calendarIsDefaultProp] = true;
				this.helpText = 'No "Country Default" invoice calendar exists for the selected country. This current invoice calendar will be set as the country default.';
				this.showConfirmationModal = true;
			}
		}
	}

	submitInvoiceCal() {
		this.calendarService.submitInvoiceCal(this.formData);
		this.showConfirmationModal = false;
	}

	cancelcConfirmationModal() {
		this.showConfirmationModal = false;
	}

	pageFormDelete(event) {
		console.log('INVOICE CALENDAR DELETE', event.data);
		if (this.calendarService.defaultIDs[event.data.countrycode] !== event.data.id) {
			this.calendarService.deleteInvoiceCal(event.data);
		} else {
			this.showConfirmationModal = true;
			this.submitLabel = '';
			this.helpText = 'Country default invoice calendar is required, you can not delete it.';
		}
	}

	showForm() {
		let showForm = false;
		if (this.calendarService.formTitle === this.calendarService.editTitle || this.calendarService.formTitle === this.calendarService.addTitle) {
			showForm = true;
		}
		return showForm;
	}

	isNewItem() {
		let isNewItem = false;
		if (this.calendarService.formTitle === this.calendarService.addTitle) {
			isNewItem = true;
		}
		return isNewItem;
	}

	newItem(event, self) {
		self.dataService.clearSelectedTableRow();
		self.calendarService.clearMessages();

		self.calendarService.formTitle = self.calendarService.addTitle;
		self.calendarService.populateNewCalendar();
		self.calendarService.invoiceDates = [];
	}

}
